import React from 'react';
import { copyFor } from '../../copy/copy';

const ShareIcon = () => (
    <svg width="14" height="10" viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg">
        <title>{copyFor('icons', 'share')}</title>
        <path
            stroke="#008EFF"
            d="M8.759 8.675V5.9s-1.222-.01-1.56-.01C5.044 5.89 2.115 7.569 1 9c.017-1.943 2.55-6.096 6.199-6.21.269-.01 1.56.005 1.56.005V0l3.956 4.34-3.956 4.335z"
            fill="none"
            fillRule="evenodd"
        />
    </svg>
);

export default ShareIcon;



// WEBPACK FOOTER //
// ./src/components/Svg/ShareIcon.jsx